/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseTemplateFolder } from '../../models/api-response-template-folder';

export interface ArchiveTemplateFolder$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  ref: string;
}

export function archiveTemplateFolder(http: HttpClient, rootUrl: string, params: ArchiveTemplateFolder$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseTemplateFolder>> {
  const rb = new RequestBuilder(rootUrl, archiveTemplateFolder.PATH, 'patch');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('ref', params.ref, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseTemplateFolder>;
    })
  );
}

archiveTemplateFolder.PATH = '/v1/api/ui/templateFolder/{ref}';
